import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhUserGroups extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhUserGroups'
  // Define default properties here
  static instanceDefaults() {
    return {
      group_name: '',
      admin_percentage: 20,
      member_percentage: 80,
      tokens_per_rating: 10
    }
  }
}
const servicePath = 'bh-user-groups';
const servicePlugin = makeServicePlugin({
  Model: BhUserGroups,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
